// Company and Private accounts (laravel App\PrivateAccount). A Private account is a person or household employing
// their own guards: no clients, districts, district managers or supervisors; the owner's locations are "My locations"
// (their own client record, never shown as a client); the wording says you/your. The server refuses the same pages.
//
// The type of the company open in the admin website is kept in localStorage 'companyType' (set at sign-in for a
// company admin, and when the super admin or a reseller opens a company), and a Private owner's own client record in
// 'ownerClientId'.

export const COMPANY = 'company'
export const PRIVATE = 'private'

// The super admin's "Private accounts" list (the Companies page with Private accounts only)
export const PRIVATE_ACCOUNTS_PATH = '/private-accounts'

// The menu's "My locations" (the owner's client record's locations page)
export const MY_LOCATIONS = '/my-locations'

// Pages a Private account does not have (typed or bookmarked): back to the dashboard
export const PRIVATE_BLOCKED = [
	'/clients',
	'/client-info/:id',
	'/client-edit/:id',
	'/district',
	'/district-edit/:id',
	'/district-info/:id',
	'/district-manager',
	'/district-manager-info/:id',
	'/district-manager-edit/:id',
	'/supervisor',
	'/supervisor-info/:id',
	'/supervisor-edit/:id',
]

export const PRIVATE_HOME = '/company-dashboard'

function read(key) {
	try {
		return localStorage.getItem(key)
	} catch (e) {
		return null
	}
}

function write(key, value) {
	try {
		if (value === null || value === undefined || value === '') {
			localStorage.removeItem(key)
		} else {
			localStorage.setItem(key, String(value))
		}
	} catch (e) {
		// Private window: the page still works, as a company's
	}
}

// "private" or "company" (anything else is a company)
export function accountType(value) {
	return value === PRIVATE ? PRIVATE : COMPANY
}

// Whether the company open in the admin website is a Private account
export function isPrivateAccount(type = read('companyType')) {
	return accountType(type) === PRIVATE
}

// Remembers the type of the company now open, from a sign-in reply's data or an auth/company/get "account"
// ({account_type, owner_client_id}) or a users row ({account_type})
export function rememberAccount(account) {
	const type = accountType(account && account.account_type)
	write('companyType', type)
	write('ownerClientId', type === PRIVATE && account && account.owner_client_id ? account.owner_client_id : null)
}

// The Private owner's own client record (their locations hang off it), or null
export function ownerClientId() {
	const id = read('ownerClientId')
	return id && Number(id) > 0 ? id : null
}

// "/client-location/<owner>" for the menu's My locations, or null while it is not known
export function myLocationsPath(id = ownerClientId()) {
	return id ? '/client-location/' + id : null
}

function matchesAny(pathname, paths) {
	const path = pathname.replace(/\/+$/, '') || '/'
	return paths.some((blocked) => {
		const base = blocked.replace(/\/:id$/, '')
		return path === base || path.startsWith(base + '/')
	})
}

// True when a Private account's admin may not open this path
export function blockedForPrivate(pathname, type = read('companyType')) {
	return isPrivateAccount(type) && typeof pathname === 'string' && matchesAny(pathname, PRIVATE_BLOCKED)
}

// The same words for both types: what the account is called on the admin website
export function accountWord(type = read('companyType')) {
	return isPrivateAccount(type) ? 'account' : 'company'
}

// The type shown on the super admin's Companies list
export function accountTypeLabel(type) {
	return accountType(type) === PRIVATE ? 'Private' : 'Company'
}
